import React from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  Input,
  FormText,
} from "reactstrap";
import "./modelcss.css";

export default function AddBillerModel({
  OnToggle,
  view,
  onChangeModelForm,
  onSubmitodelForm,
  cancel,
  values,
  labelName,
  error
}) {
  return (
    <div>
      <Modal isOpen={view} toggle={OnToggle} fullscreen={"false"}>
        <ModalBody>
          {labelName == 3 ?
          <Row xs="4">
            <Col>{labelName == 2 ? "Biller Name": "Category Name"}</Col>
            <Col style={{marginBottom :'5px'}}>
              <Input
                type="text"
                name="name"
                id="name"
                onChange={onChangeModelForm}
                value={values.name || "" }
              />
            </Col>
            <Col></Col>
            <Col style={{marginBottom :'5px'}}>
              
            </Col>
          </Row> :null }
          {labelName == 2 ?
          <span>
          <Row xs="4">
            <Col>Payee Name</Col>
            <Col style={{marginBottom :'5px'}}>
              <Input
                type="text"
                name="name"
                id="name"
                onChange={onChangeModelForm}
                value={values.name || "" }
              />
            </Col>
            <Col>Mobile Number</Col>
            <Col style={{marginBottom :'5px'}}>
            <Input
                type="text"
                name="mobileNumber"
                id="mobileNumber"
                onChange={onChangeModelForm}
                value={values.mobileNumber || "" } />
            </Col>
          </Row>
          <Row xs="4">
            <Col>GST Number</Col>
            <Col style={{marginBottom :'5px'}}>
              <Input
                type="text"
                name="gstNumber"
                id="gstNumber"
                onChange={onChangeModelForm}
                value={values.gstNumber || "" }
              />
            </Col>
            <Col>Address</Col>
            <Col style={{marginBottom :'5px'}}>
            <Input
                type="textarea"
                name="address"
                id="address"
                onChange={onChangeModelForm}
                value={values.address || "" } />
            </Col>
          </Row> </span>: null}

          <Row>
           
            <Col style={{'textAlign':"center"}}>
           {error && <FormText color="red" style={{'fontWeight':'bold'}}>{error}</FormText>}
            </Col>
           
          </Row>
          
          
        </ModalBody>
        <ModalFooter>
          <Button color="info" onClick={onSubmitodelForm}>
            Save
          </Button>
          <Button color="secondary" onClick={cancel}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/AddBillerModel.js